import { schema } from 'normalizr';

const SeriesSchema = new schema.Entity('series', {}, { idAttribute: '_id' });

const EpisodeSchema = new schema.Entity(
  'episodes',
  { series: SeriesSchema },
  { idAttribute: '_id' },
);

const TimelineSchema = new schema.Entity(
  'timelines',
  { episode: EpisodeSchema },
  { idAttribute: '_id' },
);

export const LinearChannelSchema = new schema.Entity(
  'linearChannels',
  { timelines: [TimelineSchema] },
  { idAttribute: 'id' },
);

export const LinearChannelSlugSchema = new schema.Entity(
  'linearChannelSlugs',
  { channel: LinearChannelSchema },
  {
    idAttribute: 'slug',
    processStrategy: ({ _id, slug }) => ({
      channel: _id,
      slug,
    }),
  },
);

export const LinearChannelNumberSchema = new schema.Entity(
  'linearChannelNumbers',
  { channel: LinearChannelSchema },
  {
    idAttribute: 'number',
    processStrategy: ({ _id, number }) => ({
      channel: _id,
      number,
    }),
  },
);

const CategorySchema = new schema.Entity('categories');

export const CategoryListSchema = new schema.Array(CategorySchema);
